import React, { useEffect, useState } from "react";
import { useToaster } from "../../../Toaster/Toaster";
import { useLoader } from "../../../Loader/LoaderContext";
import { profileDto } from "../../../api/Dtos/profileDto";
import { useNavigate } from "react-router-dom";
import { getService, postService } from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import { getSHiftDisplayName } from "../../../utility/RolesUtility";
import DynamicTextPopup from "../../Portals/Modals/dynamicTextPopup";
import DynamicSuccessPopup from "../../Portals/Modals/DynamicSuccessPopup";
import ServicesOffered from "../../Portals/leads/ServicesOffered";
import LeaderShipTeam from "../../Portals/leads/LeaderShipTeam";
import CenterAndLocation from "../../Portals/leads/CenterAndLocation";
import DateService from "../../../servce/DateService";

function HospitalView() {
  const [isOpen, setOpen] = useState(false);
  const { showToast } = useToaster();
  const { setLoading } = useLoader();
  const [data, setData] = useState<any | null>(null);
  const router = useNavigate();
  const leadId = localStorage.getItem("leadId");
  const onEdit = () => {
    router(
      "/vendorDashboard/activateDashbord/HospitalViewProfile/hospitalProfile?id="
    );
  };
  const sendForApproval = () => {
    setShowConfirmation(true);
  };
  const closePopup = () => {
    setOpen(false);
    fetchDetails();
  };
  const handleClosePopup = () => setShowConfirmation(false);
  const saveData = async () => {
    setLoading(true);
    try {
      let payload = {
        ...data,
        leadId: leadId,
        profilingStatus: "PUBLISHED",
      };

      const response = await postService(API_ENDPOINTS.saveProfile, payload);
      if (response) {
        setShowConfirmation(false);
        setOpen(true);

        showToast("Profile has been updated successfully.", "success", "");
      }
    } catch (error: any) {
      // setApiError(error.response?.data?.message);
      console.error("Login error:", error);
      if (error.response?.data?.message === "Invalid Otp. Please try again.") {
      }
    } finally {
      setLoading(false);
    }
  };
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [userInfo, setUserInfo] = useState<any>(null);
  const [isApprove, setIsApprove] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedUserInfo = localStorage.getItem("userInfo");
      if (storedUserInfo) {
        setUserInfo(JSON.parse(storedUserInfo)); // Set userInfo from localStorage
      }
    }
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      let url: string;
      const response = await getService(
        API_ENDPOINTS.getProfile + "?leadId=" + leadId
      ); // Fetch post details using 'id'
      setData(response.data);

      setTimeout(() => {
        setLoading(false); // Stop loader after 500ms
        // setIsLoading(false); // Stop local loading
      }, 1000);
    } catch (error) {
      console.error("Error fetching post details:", error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <>
      {
        //         (userInfo?.companyType === 'HOSPITAL' && data?.profileStatus ==='CENTER_AND_LOCATION') ||
        // (userInfo?.companyType === 'COMPANY' && data?.profileStatus ==='AUTHORS') ||
        // (userInfo?.companyType === 'EVENT_ORGANIZER' && data?.profileStatus ==='EVENTS')
        //  &&
        <div className="relative rounded-lg">
          {/* Background Image */}
          <div className="relative w-full h-[180px]">
            <img
              src="/images/hospitalMask.svg"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Profile Section */}
          <div className="relative px-6 pt-4">
            {/* Profile Image (Overlapping Background) */}
            <div className="absolute -top-12 left-6">
              <img
                src={data?.imageDto?.documentUrl || "/images/userImg.svg"}
                className="w-[96px] h-[96px] rounded-lg border border-white shadow-lg bg-white"
              />
            </div>

            {/* Name, Email, and Badge */}
            <div className="flex justify-between items-center">
              <div className="ml-[120px] w-[50%]">
                <p className="font-bold text-[20px] text-gray-900 flex items-center w-[100%] ">
                  <span className="line-clamp-1">{data?.name || "NA"}</span>
                  {(!data?.profilingStatus ||
                    data?.profilingStatus === "NONE" ||
                    data?.profilingStatus == "SEND_FOR_APPROVAL" ||
                    data.profilingStatus == "TO_SEND_FOR_APPROVAL") && (
                    <span className="ml-3 text-[12px] bg-[#FEF3C7] text-[#92400E] px-2 py-1 rounded-xl text-nowrap ">
                      {!data?.profilingStatus ||
                      data?.profilingStatus === "NONE"
                        ? "Yet to receive for Approval"
                        : data?.profilingStatus == "SEND_FOR_APPROVAL"
                        ? `Received for Approval on ${DateService.formatDate(
                            data?.sendForAprvlOn,
                            DateService.formats.DD_MM_YYYY
                          )}`
                        : data?.profilingStatus === "PUBLISHED"
                        ? `Published on ${DateService.formatDate(
                            data?.publishedOn,
                            DateService.formats.DD_MM_YYYY
                          )}`
                        : data?.profilingStatus === "TO_SEND_FOR_APPROVAL"
                        ? "Not sent for approval yet"
                        : ""}
                    </span>
                  )}
                  {data?.profilingStatus === "PUBLISHED" && (
                    <span className="ml-3 text-[12px] bg-[#D1FAE5] text-[#065F46] px-2 py-1 rounded-xl">
                      {!data?.profilingStatus ||
                      data?.profilingStatus === "NONE"
                        ? "Yet to send for Approval"
                        : data?.profilingStatus == "SEND_FOR_APPROVAL"
                        ? "Awaiting for Approval"
                        : data?.profilingStatus === "PUBLISHED"
                        ? `Published on ${DateService.formatDate(
                            data?.publishedOn,
                            DateService.formats.DD_MM_YYYY
                          )}`
                        : ""}
                    </span>
                  )}
                </p>
                <p className="text-sm text-gray-600">{data?.email || "NA"}</p>
              </div>

              {/* Edit Profile Button (Right-Aligned) */}

              <div className="absolute  right-6">
                {userInfo?.roles === "PUBLISHER" &&
                  data?.profilingStatus === "SEND_FOR_APPROVAL" && (
                    <button
                      className="border border-gray-300 px-4 py-2 rounded-md text-sm text-gray-700"
                      type="button"
                      onClick={onEdit}
                    >
                      Edit Profile
                    </button>
                  )}
                {userInfo?.roles === "PUBLISHER" &&
                  data?.profilingStatus === "SEND_FOR_APPROVAL" && (
                    <button
                      type="submit"
                      className="ml-3 px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base"
                      onClick={sendForApproval}
                    >
                      Approve & Publish profile
                    </button>
                  )}
              </div>
            </div>
          </div>

          {/* Additional Content Below */}
          <div className="px-6 mt-6">
            <div className="bg-white px-6 pb-6">
              <div className="font-Inter text-base pt-7">
                <p className="text-base font-semibold text-gray-900 pb-2">
                  Hospital Info
                </p>
                <div className="scroolCls">
                  <p className="text-gray-800">{data?.hospitalInfo || "NA"}</p>
                </div>
              </div>
              <div className="grid grid-cols-3 font-Inter gap-10  pb-5 pt-5">
                <div>
                  <p className="text-sm font-normal text-gray-700 pb-1">
                    Phone Number
                  </p>
                  <p className="font-semibold text-base text-gray-900">
                    {data?.phoneNo || "NA"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-normal text-gray-700 pb-1">
                    Specialization
                  </p>
                  <p className="font-semibold text-base text-gray-900">
                    {data?.specialization || "NA"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-normal text-gray-700 pb-1">
                    Hospital Size
                  </p>
                  <p className="font-semibold text-base text-gray-900">
                    {getSHiftDisplayName(data?.size) || "NA"}
                  </p>
                </div>
              </div>
              <div className=" font-Inter">
                <p className="text-sm font-normal text-gray-700 pb-1">
                  Address
                </p>
                <p className="font-semibold text-base text-gray-900 pb-4">
                  {[
                    data?.streetAddress,
                    data?.apartment,
                    data?.mtCountryDto?.name,
                    data?.state,
                    data?.city,
                    data?.postalCode,
                  ].some((value) => value?.toString().trim())
                    ? [
                        data?.streetAddress,
                        data?.apartment,
                        data?.mtCountryDto?.name,
                        data?.state,
                        data?.city,
                        data?.postalCode,
                      ]
                        .filter((value) => value?.toString().trim())
                        .join(", ")
                    : "NA"}
                </p>
              </div>
            </div>
          </div>
          <div className="px-6">
            <ServicesOffered submittedData={data} />
          </div>
          <div className="px-6">
            <LeaderShipTeam submittedData={data} />
          </div>
          <div className="px-6 pb-8">
            <CenterAndLocation submittedData={data} />
          </div>
        </div>
      }
      {showConfirmation && (
        <DynamicTextPopup
          onClose={handleClosePopup}
          title="Confirm Approval & Publish"
          body=" Are you sure you want to approve and publish this profile? Once published, the profile will be visible to the public. "
          confirmButtonName="Approve & Publish"
          closeButtonName="Cancel"
          onConfirm={saveData}
        />
      )}
      {isOpen && (
        <DynamicSuccessPopup
          onClose={closePopup}
          title="Profile Published Successfuly"
          body="The profile has been approved and published. It is now live and visible to the public."
          closeButtonName="Okay"
        />
      )}
    </>
  );
}

export default HospitalView;
